import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {ContactActionPopover} from '/component/partial/profile/ContactActionPopover';
import {
  emailById,
  nameById,
  phoneNumberById,
} from '/redux/selector/candidate.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      name: nameById,
      phoneNumber: phoneNumberById,
      accountEmail: emailById,
    }),
  ),
)(ContactActionPopover);
